import { SubscriptionTier } from '@/../generated-client/models';
import type { MiniOrganization } from '@/../generated-client/models';

export interface Entitlements {
  effectiveTier: SubscriptionTier;
  canSendEmergency: boolean;
  canViewEmergencyMap: boolean;
  canViewMap: boolean;
  canBeAssignedToPvdConfig: boolean;
  canBeAssignedToRespondConfig: boolean;
  orgHasOpsInventory: boolean;
  orgHasRespondInventory: boolean;
  orgHasAnyPaidInventory: boolean;
}

// Least privilege: a slow or failed org load must never grant paid access (spec §9).
export const LEAST_PRIVILEGE: Entitlements = {
  effectiveTier: SubscriptionTier.Connect,
  canSendEmergency: false,
  canViewEmergencyMap: false,
  canViewMap: false,
  canBeAssignedToPvdConfig: false,
  canBeAssignedToRespondConfig: false,
  orgHasOpsInventory: false,
  orgHasRespondInventory: false,
  orgHasAnyPaidInventory: false,
};

const TIER_ORDER: Record<SubscriptionTier, number> = {
  [SubscriptionTier.Connect]: 0,
  [SubscriptionTier.Ops]: 1,
  [SubscriptionTier.Respond]: 2,
};

export const tierRank = (tier: SubscriptionTier): number => TIER_ORDER[tier] ?? 0;

export const tierAtLeast = (
  tier: SubscriptionTier,
  minimum: SubscriptionTier,
): boolean => tierRank(tier) >= tierRank(minimum);

export function deriveEntitlements(
  mini: MiniOrganization | null | undefined,
): Entitlements {
  if (!mini) return LEAST_PRIVILEGE;
  return {
    effectiveTier: mini.effective_tier ?? SubscriptionTier.Connect,
    canSendEmergency: mini.can_send_emergency ?? false,
    canViewEmergencyMap: mini.can_view_emergency_map ?? false,
    canViewMap: mini.can_view_map ?? false,
    canBeAssignedToPvdConfig: mini.can_be_assigned_to_pvd_config ?? false,
    canBeAssignedToRespondConfig: mini.can_be_assigned_to_respond_config ?? false,
    orgHasOpsInventory: mini.org_has_ops_inventory ?? false,
    orgHasRespondInventory: mini.org_has_respond_inventory ?? false,
    orgHasAnyPaidInventory: mini.org_has_any_paid_inventory ?? false,
  };
}
